import type { SiteFooterLink } from '../../types/content';

const hiddenFooterLabels = new Set([
  'rekisteriseloste',
  'tietosuoja',
  'tietosuojaseloste',
  'asiakastuki',
  'usein kysyttya',
  'usein kysyttyä',
]);

const normalizeLabel = (value?: string) =>
  (value || '')
    .trim()
    .toLocaleLowerCase('fi-FI')
    .normalize('NFD')
    .replace(/[\u0300-\u036f]/g, '');

export const shouldHideFooterLink = (link: Pick<SiteFooterLink, 'label' | 'groupLabel'>) => {
  const label = normalizeLabel(link.label);
  const groupLabel = normalizeLabel(link.groupLabel);
  return hiddenFooterLabels.has(label) && !groupLabel;
};

export const filterVisibleFooterLinks = <T extends SiteFooterLink>(links: T[]) =>
  links.filter((link) => !shouldHideFooterLink(link));
